module.exports = __webpack_public_path__ + "static/boost_conversions_tactics-f9e4dcd684c1d1206f880a76d12a70ba.png";